// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataHotlinksSite = createAsyncThunk('appUsers/getAllDataHotlinksSite', async id => {
  const response = await axios.get('https://apiv4.opentlv.com/api/v3/site/hotlinks/all',  { params: { id} })
  return response.data
})

export const getDataHotlinksSite = createAsyncThunk('appUsers/getDataHotlinksSite', async params => {
  const response = await axios.get('https://apiv4.opentlv.com/api/v3/site/hotlinks/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv4.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const addHotlink = createAsyncThunk('appUsers/addHotlink', async (hotlink,  { dispatch, getState }) => {
 
  await axios.post('https://apiv4.opentlv.com/api/v3/site/hotlink/add', hotlink)
  console.log("addHot")

  await dispatch(getDataHotlinksSite(getState().hotlinksSite.params))
  console.log(hotlink)
  return site
})
export const editHotlink = createAsyncThunk('appUsers/editHotlink', async (hotlink,  { dispatch, getState }) => {
 
  await axios.post('https://apiv4.opentlv.com/api/v3/site/hotlink/edit', hotlink)
  console.log("addHot")
  await dispatch(getDataHotlinksSite(getState().hotlinksSite.params))
  console.log(hotlink)
  return site
})

export const deleteHotlink = createAsyncThunk('appUsers/deleteHotlink', async (id, { dispatch, getState }) => {
  await axios.delete('https://apiv4.opentlv.com/api/v3/site/hotlink/delete',  {params: {id}})
  await dispatch(getDataHotlinksSite(getState().hotlinksSite.params))
  return id

})


export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataHotlinksSite.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataHotlinksSite.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
